export default __webpack_public_path__ + "static/media/694.6197f14f.png";